import { useEffect, useState } from "react";

const ZEFFY_URL = "https://www.zeffy.com/en-CA/ticketing/recalibrate-retreat-2";

export const StickyReserveBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Reveal after the hero has scrolled past (~500px)
      setVisible(window.scrollY > 500);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-reserve-bar"
      aria-hidden={!visible}
      className={`md:hidden fixed bottom-0 left-0 right-0 z-[55] px-4 pb-4 pt-3 bg-[#F4F1EA]/95 backdrop-blur-md border-t border-[#D4CFC4]/60 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)" }}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[9px] uppercase tracking-[0.3em] text-[#9E6D55] leading-none">
            Your Investment &middot; Limited spots available
          </p>
          <p className="mt-1 font-heading text-sm italic text-[#2C3029] leading-tight">
            From $2,799 USD &middot; Oct 12–19, 2027
          </p>
        </div>
        <a
          href={ZEFFY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-reserve-cta"
          className="flex-shrink-0 inline-flex items-center px-6 py-3 bg-[#2C3029] text-[#F4F1EA] text-[10px] uppercase tracking-[0.25em] hover:bg-[#9E6D55] transition-colors duration-500"
        >
          Reserve Now
        </a>
      </div>
    </div>
  );
};

export default StickyReserveBar;
